import { CircleSwitcherItem, Switcher } from "@similarweb/ui-components";
import { EMetricType } from "./types";
import { useOverlapOvertimeContext } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/context";
import { i18nFilter } from "app/filters/i18nFilter";
import styled from "styled-components";

const { TOTAL, PER_SITE } = EMetricType;

const StyledSwitcher = styled(Switcher)`
    margin-right: 0px;
`;

export const MetricTypeToggle = () => {
    const { selectedMetric, setSelectedMetric } = useOverlapOvertimeContext();
    const i18n = i18nFilter();
    const onItemClick = (index) => {
        setSelectedMetric(index);
    };
    return (
        <StyledSwitcher
            selectedIndex={selectedMetric}
            onItemClick={onItemClick}
            customClass={"CircleSwitcher"}
        >
            <CircleSwitcherItem
                key={TOTAL}
                selected={selectedMetric === TOTAL}
            >
                {i18n("overlap.overtime.metric.toggle.total")}
            </CircleSwitcherItem>
            <CircleSwitcherItem
                key={PER_SITE}
                selected={selectedMetric === PER_SITE}
                className={"last"}
            >
                {i18n("overlap.overtime.metric.toggle.per.site")}
            </CircleSwitcherItem>
        </StyledSwitcher>
    );
};
